import { useEffect, useState } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useBusinessDay } from '../../../../shared/hooks/useBusinessDay.js';
import { billRefLabel, type BillRef } from '../../../../shared/contracts/bill-ref.js';

/**
 * What a bill's pages are headed with - its job, dealer and date - read from
 * the claim the page works on (`path`: the billing claim or its review).
 */
export function useClaimBill(path: string | undefined): {
  readonly bill: string;
  readonly error: string | null;
} {
  const { token } = useAuth();
  const { day } = useBusinessDay();
  const [read, setRead] = useState<{ bill: BillRef | null }>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!path) return;
    let alive = true;
    apiRequest<{ readonly bill: BillRef | null }>(path, { token })
      .then((d) => { if (alive) setRead({ bill: d.bill }); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [path, token]);

  return {
    bill: read ? billRefLabel(read.bill, day) : '',
    error,
  };
}
